import { useState, useEffect } from "react";
import { shoppingCentresService } from "@/api/services/shoppingCentres.service";
import { isUuid } from "@/utils/validation";
/**
 * Resolves a shopping centre value for display.
 * If the value is a UUID, fetches the shopping centre by ID and returns scName.
 * Otherwise returns the value as-is (assumed to be a display name).
 */
export function useShoppingCentreDisplay(value) {
    const [display, setDisplay] = useState(() => {
        if (!value?.trim())
            return "";
        if (isUuid(value))
            return value; // Show UUID while loading
        return value;
    });
    useEffect(() => {
        if (!value?.trim()) {
            setDisplay("");
            return;
        }
        if (!isUuid(value)) {
            setDisplay(value);
            return;
        }
        let cancelled = false;
        shoppingCentresService
            .getShoppingCentre(value)
            .then((res) => {
            if (!cancelled && res.data?.scName) {
                setDisplay(res.data.scName);
            }
        })
            .catch(() => {
            if (!cancelled) {
                setDisplay(value); // Fallback to raw value on error
            }
        });
        return () => {
            cancelled = true;
        };
    }, [value]);
    return display;
}
